module.exports = __webpack_public_path__ + "media/images/front/event/dummypic1-df8e3321577e5496843f7c0be5799dd2.png";